import { createRoot } from 'react-dom/client';
import { ArtistFavorites } from '../ArtistFavorites';

export class ArtistFavoritesBlock {
  // These are required by Editor.js interface but not currently used
  // @ts-expect-error - Required by Editor.js interface
  private _api: any;
  // @ts-expect-error - Required by Editor.js interface
  private _readOnly: boolean;
  private data: { artistId: string };
  private wrapper: HTMLElement | null = null;

  static get toolbox() {
    return {
      title: 'Artist Favorites',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"></path></svg>'
    };
  }

  static get isReadOnlySupported() {
    return true;
  }

  constructor({ data, api, readOnly }: any) {
    this._api = api;
    this._readOnly = readOnly;
    this.data = data || { artistId: '' };
  }

  render() {
    this.wrapper = document.createElement('div');
    this.wrapper.classList.add('artist-favorites-block');

    if (this.data.artistId) {
      const root = createRoot(this.wrapper);
      root.render(<ArtistFavorites artistId={this.data.artistId} />);
    } else {
      this.wrapper.innerHTML = `
        <div class="bg-gray-800 border-2 border-dashed border-gray-600 rounded-lg p-8 text-center">
          <p class="text-gray-400">⭐ Artist Favorites Block</p>
          <p class="text-sm text-gray-500 mt-2">Artist ID will be set automatically</p>
        </div>
      `;
    }

    return this.wrapper;
  }

  save() {
    return this.data;
  }

  validate(_savedData: any) {
    return true;
  }

  renderSettings() {
    return [];
  }
}
